<div class="table-container">
  <div class="data-card">
    <div class="table-wrapper">
      <table mat-table [dataSource]="dataSource" matSort>

    <!-- Select Column -->
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox></mat-checkbox>
      </td>
    </ng-container>

    <!-- RefCode Column -->
    <ng-container matColumnDef="refcode">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Reference Code </th>
      <td mat-cell *matCellDef="let row">
        <span matRipple class="ref-code" [cdkCopyToClipboard]="row.referenceCode" (click)="onCopyRefCode(row.referenceCode)">{{row.referenceCode}}</span>
      </td>
    </ng-container>

    <!-- Brand Column -->
    <ng-container matColumnDef="brand">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Brand/Product </th>
      <td mat-cell *matCellDef="let row">
        {{row.brand}} 
        <div class="cell-secondary">{{row.product}}</div>
      </td>
    </ng-container>

    <!-- RefTitle Column -->
    <ng-container matColumnDef="reftitle">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Title </th>
      <td mat-cell *matCellDef="let row"> {{row.version}} </td>
    </ng-container>

    <!-- Agency/Office Column -->
    <ng-container matColumnDef="agency">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Agency/Office </th>
      <td mat-cell *matCellDef="let row">
        {{row.agency | objectdesc}} 
        <div class="cell-secondary">{{row.commercialOffice | objectdesc}}</div>
      </td>
    </ng-container>

    <!-- Status Column -->
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
      <td mat-cell *matCellDef="let row">
        <span class="badge" [ngClass]="{
          'badge-new': row.status.id == 1,
          'badge-pending': row.status.id == 2,
          'badge-processing': row.status.id == 3,
          'badge-rejected': row.status.id == 4 || row.status.id == 7,
          'badge-reload': row.status.id == 5,
          'badge-approved': row.status.id == 6
        }">
          <span class="badge-dot"></span>
          {{row.status | objectdesc}}
        </span>
        @if( showTimeFlag(row) == 48) {
          <span class="time-flag time-flag-48">
            <i class="fa-solid fa-exclamation"></i>
            &nbsp;+ 48hs
          </span> 
        }
        @if( showTimeFlag(row) == 24) {
          <span class="time-flag time-flag-24">
            <i class="fa-solid fa-exclamation"></i>
            &nbsp;+ 24hs
          </span> 
        }

      </td>
    </ng-container>

    <!-- Type Column -->
    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Type </th>
      <td mat-cell *matCellDef="let row"> {{row.type | objectdesc}} </td>
    </ng-container>

    <!-- Created Column -->
    <ng-container matColumnDef="created">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ ( showUploadedDate ? 'Uploaded' : 'Created' ) }} </th>
      <td mat-cell *matCellDef="let row"> {{(showUploadedDate ? row.dateUploaded : row.dateCreated) | date:'d/M/yyyy'}} </td>
    </ng-container>

    <!-- Actions Column -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef> Actions </th>
      <td mat-cell *matCellDef="let row">
        <div class="actions">
          <button matButton class="act-btn" (click)="onViewHistory(row)" matTooltip="View History">
            <i class="fa-regular fa-message"></i>
          </button>
          @if( row.status.id == 7 ) {
            <button matButton class="act-btn" (click)="onViewSpecCheckReport(row)" matTooltip="View Spec Check Report">
              <i class="fa-solid fa-circle-info" style="color:#DC2606"></i>
            </button>
          }
          @if( allowUploadCommercial(row) ) {
            <button matButton class="act-btn" (click)="onUploadCommercial(row)" matTooltip="Upload Media">
              <i class="fa-solid fa-upload"></i>
            </button>
          }
          @if( allowViewProxy(row) ) {
            <button matButton class="act-btn" (click)="onViewProxy(row)" matTooltip="View Proxy">
              <i class="fa-solid fa-film"></i>
            </button>
          }
          @if( allowDeleteCommercial(row) ) {
            <button matButton class="act-btn danger" (click)="onDeleteCommercial(row)" matTooltip="Delete">
              <i class="fa-regular fa-trash-can"></i>
            </button>
          }
        </div>
      </td>
    </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>

    <mat-paginator
      [pageSizeOptions]="[10, 25, 50, 100]"
      showFirstLastButtons
      aria-label="Select page">
    </mat-paginator>
  </div>

  <button class="fab fab-left" (click)="onNewCommercial()">
    <i class="fa-solid fa-plus"></i>
    New Commercial
  </button>
</div>
